var ApplicationBarMenuType;
(function (ApplicationBarMenuType) {
    /**
     * Linear menu type, on desktop it is the menu that renders on the left side of the screen.
     */
    ApplicationBarMenuType["LINEAR"] = "linear";
    /**
     * Spotlight meny type, this makes it so the menu renders on a Modal with a spotlight, covering the whole screen.
     */
    ApplicationBarMenuType["SPOTLIGHT"] = "spotlight";
})(ApplicationBarMenuType || (ApplicationBarMenuType = {}));
export { ApplicationBarMenuType, };
//# sourceMappingURL=application-bar-constants.js.map